export interface LastRaftIndex {
    lastEtag: number;
}